import React, { useEffect } from 'react';
import supportedApps from '../../data/supportedApps.json';
import { defaultFavicon } from '../../utils/iconUtils';

interface FaviconLoaderProps {
  originalUrl: string;
  setFavicon: (url: string) => void;
  target?: string;
}

const FaviconLoader: React.FC<FaviconLoaderProps> = ({
  originalUrl,
  setFavicon,
  target,
}) => {
  useEffect(() => {
    // Définir l'icône par défaut immédiatement pour éviter l'effet clignotant
    setFavicon(defaultFavicon);

    const loadFavicon = async () => {
      try {
        if (target) {
          const app =
            target &&
            supportedApps.find(
              (app) => app.label.toLowerCase() === target.toLowerCase(),
            );

          if (app) {
            setFavicon(app.value);
            return;
          }
        }

        // Uniquement essayer de charger la favicon originale si target n'est pas trouvé
        const faviconUrl = new URL('/favicon.ico', originalUrl).href;

        // Précharger l'image avant de mettre à jour l'état
        const img = new Image();
        img.src = faviconUrl;
        img.onload = () => setFavicon(faviconUrl);
        // En cas d'erreur, nous gardons la favicon par défaut déjà définie
      } catch (error) {
        console.error('Error loading favicon:', error);
        // Pas besoin de rappeler setFavicon car nous avons déjà défini defaultFavicon
      }
    };

    loadFavicon();
  }, [originalUrl, setFavicon, target]);

  return null;
};

export default FaviconLoader;
